import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TUserMgmtConnectedEmerchantsStore,
	TConnectedEmerchantsRequest,
	TConnectedEmerchantsResponsePayload,
	TDetachEmKeycloakUserRequest,
} from './types';

const initialState: TUserMgmtConnectedEmerchantsStore = {
	connectedEmerchants: null,
	connectedEmerchantsLoading: false,
	connectedEmerchantsFailure: false,
	detachEmUserLoading: false,
	detachEmUserSuccess: false,
};

const userMgmtConnectedEmerchants = createSlice({
	name: '@@userMgmtConnectedEmerchants',
	initialState,
	reducers: {
		getUserMgmtConnectedEmerchantsRequest: (
			state: TUserMgmtConnectedEmerchantsStore,
			action: PayloadAction<TConnectedEmerchantsRequest>,
		) => {
			const s = state;
			s.connectedEmerchantsLoading = true;
			s.connectedEmerchantsFailure = false;
		},
		getUserMgmtConnectedEmerchantsSuccess: (
			state: TUserMgmtConnectedEmerchantsStore,
			action: PayloadAction<TConnectedEmerchantsResponsePayload>,
		) => {
			const s = state;
			s.connectedEmerchants = action.payload;
			s.connectedEmerchantsLoading = false;
			s.connectedEmerchantsFailure = false;
		},
		getUserMgmtConnectedEmerchantsFailure: (state: TUserMgmtConnectedEmerchantsStore) => {
			const s = state;
			s.connectedEmerchantsLoading = false;
			s.connectedEmerchants = null;
			s.connectedEmerchantsFailure = true;
		},

		detachUserMgmtEmUserRequest: (
			state: TUserMgmtConnectedEmerchantsStore,
			action: PayloadAction<TDetachEmKeycloakUserRequest>,
		) => {
			const s = state;
			s.detachEmUserLoading = true;
			s.detachEmUserSuccess = false;
		},
		detachUserMgmtEmUserSuccess: (state: TUserMgmtConnectedEmerchantsStore) => {
			const s = state;
			s.detachEmUserLoading = false;
			s.detachEmUserSuccess = true;
		},
		detachUserMgmtEmUserFailure: (state: TUserMgmtConnectedEmerchantsStore) => {
			const s = state;
			s.detachEmUserLoading = false;
			s.detachEmUserSuccess = false;
		},
	},
});

export default userMgmtConnectedEmerchants.reducer;
export const {
	getUserMgmtConnectedEmerchantsRequest,
	getUserMgmtConnectedEmerchantsSuccess,
	getUserMgmtConnectedEmerchantsFailure,
	detachUserMgmtEmUserRequest,
	detachUserMgmtEmUserSuccess,
	detachUserMgmtEmUserFailure,
} = userMgmtConnectedEmerchants.actions;
